import axios from 'axios';
import { getType } from 'typesafe-actions';

import store from '../../app/store';
import { getToken, getXSRFToken } from '../dtos/auth.dtos';
import { spinnerStart, spinnerStop } from '../actions/spinner.actions';
import { apiUrl } from '../constants/apiUrl';
import { logoutActions } from '../actions/auth.actions';

const apiClient = axios.create({
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json',
    'X-XSRF-TOKEN': getXSRFToken()
  }
});

export const startSpinner = () => {
  store.dispatch({ type: getType(spinnerStart) });
}

export const stopSpinner = () => {
  store.dispatch({ type: getType(spinnerStop) });
}

apiClient.interceptors.request.use(async (config) => {
  await startSpinner();
  const authToken = await getToken();
  config.headers.Authorization = `Bearer ${authToken}`;
  return config;
}, error => {
  return Promise.reject(error);
});

apiClient.interceptors.response.use(
  async response => {
    await stopSpinner();
    return response;
  },
  async error => {
    await stopSpinner();

    const { status } = error.response;

    if (status === 401 || status === 403) {
      sessionStorage.removeItem("storageAuthToken");
      sessionStorage.removeItem("storageRoles");
      sessionStorage.removeItem("storageAuthInformation");

      store.dispatch({ type: getType(logoutActions.request) });
    }

    return Promise.reject(error);
  }
);

export default apiClient;
